export const isReferralOut = item =>
  [item, item?.sfda, item?.price_list, item?.item?.sfda, item?.favItem, item?.favItem?.sfda]
    .some(source => [true, 1, 'true', '1'].includes(source?.is_referral_out))

export const splitPreAuthPayloadByReferral = payload =>
  [false, true]
    .map(isReferral => ({
      ...payload,
      is_referral: isReferral,
      items: (payload?.items || [])
        .filter(item => isReferralOut(item) === isReferral)
        .map(({ is_referral_out, ...item }) => item)
    }))
    .filter(payloadGroup => payloadGroup.items.length > 0)
